// First-run onboarding: a skippable 3-card overlay, shown once per user.
import { activeUser } from '../lib/auth.js';

const KEY = (u) => `grit-onboarded-${u}`;

const CARDS = [
  {
    art: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-9 h-9"><path d="M6.5 6.5l11 11M4 8l4-4M16 20l4-4M3 11l2-2M13 21l2-2M19 9l2-2M9 19l2-2"/></svg>`,
    title: 'Welcome to Grit',
    body: 'Your lifting, running, food and weight in one place. Log it as you go. You can export a backup any time in Settings.',
  },
  {
    art: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-9 h-9"><rect x="3" y="4" width="18" height="16" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="9" x2="9" y2="20"/></svg>`,
    title: 'Five tabs, that is it',
    body: "Today is what's on right now. Running is your runs and cardio. Food is your calories for the day. Weight is your weigh-ins and plan. Settings is your program and goals.",
  },
  {
    art: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-9 h-9"><circle cx="12" cy="12" r="9"/><polyline points="8 12 11 15 16 9"/></svg>`,
    title: 'The book picks your next weight',
    body: 'Type your reps and check off each set. Hit the top of the range with a rep or two left and the weight goes up on your very next set, just like Bigger Leaner Stronger says.',
  },
];

export function maybeShowOnboarding() {
  const u = activeUser();
  if (!u || localStorage.getItem(KEY(u))) return;
  showOnboarding();
}

function showOnboarding() {
  let i = 0;
  const overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[120] bg-pagebg text-ink flex flex-col';

  function done() {
    localStorage.setItem(KEY(activeUser()), '1');
    overlay.remove();
  }

  function paint() {
    const c = CARDS[i];
    const last = i === CARDS.length - 1;
    overlay.innerHTML = `
      <div class="flex justify-end p-5">
        <button id="skip" class="text-grit font-semibold text-[17px] min-h-[44px] px-2">Skip</button>
      </div>
      <div class="flex-1 flex flex-col items-center justify-center text-center px-8">
        <div class="w-20 h-20 rounded-3xl bg-grit-soft text-grit flex items-center justify-center mb-7">${c.art}</div>
        <h1 class="grit-title">${c.title}</h1>
        <p class="text-[17px] text-inksoft leading-relaxed mt-3 max-w-xs">${c.body}</p>
      </div>
      <div class="flex items-center justify-center gap-2 mb-6">
        ${CARDS.map((_, k) => `<span class="h-2 rounded-full transition-all ${k === i ? 'w-6 bg-brand' : 'w-2 bg-[rgba(60,60,67,0.2)]'}"></span>`).join('')}
      </div>
      <div class="px-6 pb-[max(env(safe-area-inset-bottom),1.5rem)]">
        <button id="next" class="grit-btn">${last ? 'Start training' : 'Next'}</button>
      </div>`;
    overlay.querySelector('#skip').onclick = done;
    overlay.querySelector('#next').onclick = () => { if (last) done(); else { i++; paint(); } };
  }

  paint();
  document.body.appendChild(overlay);
}
